import { Box, Stack, Typography } from "@mui/material";
import { RegionScope } from "~/hooks/useScope";
import { PlatformBreadcrumbs } from "~/pages/platform/components";
import { AddButton } from "~/components/add-button";
import { setDocumentTitle } from "~/lib/commonUtils";
import { PlatformPoliciesTable } from "./components/PlatformPoliciesTable/PlatformPoliciesTable";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";
import { usePlatformPoliciesTableData } from "./hooks/usePlatformPoliciesTableData";
import { usePlatformPoliciesFilterContext } from "./hooks/usePlatformPoliciesFilterContext";

export interface PlatformPoliciesPageProps {
  scope: RegionScope;
}

export function PlatformPoliciesPage({ scope }: PlatformPoliciesPageProps) {
  const { isFeatureEnabled } = useFeatureFlags();
  const title = "Platform Policies";
  setDocumentTitle(title);

  const { tableProps } = usePlatformPoliciesTableData();

  return (
    <Box>
      <PlatformBreadcrumbs currentPage={title} showPlatformPolicies={false} />
      <Stack direction="row" justifyContent="space-between" mb={5}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>
        {isFeatureEnabled("Platform Policy Add") && (
          <AddButton href="/policies/add" />
        )}
      </Stack>
      <Stack gap={3}>
        <PlatformPoliciesFilterForm />
        <PlatformPoliciesTable {...tableProps} />
      </Stack>
    </Box>
  );
}

function PlatformPoliciesFilterForm() {
  const { filterForm } = usePlatformPoliciesFilterContext();
  return <>{filterForm}</>;
}
